export const getRegionFromHost = (host = "") => {
  if (!host && globalThis.window?.location?.hostname) host = globalThis.window.location.hostname || "";
  if (host.includes("truman.bayer.cn")) return "cn";
  if (host.includes(".us.")) return "us";
  if (host.includes(".eu.")) return "eu";
  return "eu";
};

export const buildDocumentUrl = (env = "production", region = "eu") => {
  switch (region) {
    case "cn":
      return env === "staging"
        ? "documents.staging.truman.bayer.cn"
        : "documents.truman.bayer.cn";
    case "us":
      return env === "staging"
        ? "documents.us.staging.truman.bayer.com"
        : "documents.us.truman.bayer.com";
    case "eu":
    default:
      return env === "staging"
        ? "documents.eu.staging.truman.bayer.com"
        : "documents.eu.truman.bayer.com";
  }
};
